import IconButton from '@anm/components/buttons/IconButton';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const shareButtonWrapperOnMobiles = media.tablet`
  min-width: 120px;
  margin: 5px;
  flex: 1;
`;

export const ShareButtonWrapper = styled(IconButton)`
  padding: 0 18px;
  min-width: 150px;
  margin-left: 10px;
  line-height: 19px;
  font-weight: bold;

  &:before {
    margin-right: 12px;
  }

  ${shareButtonWrapperOnMobiles};
`;
